import React from 'react';

export default function RideLoader({
  title = 'Setting up your ride',
  subtitle = 'Connecting to nearby autos...',
  className = '',
}) {
  return (
    <div className={`rapido-screen rapido-loading-screen ${className}`.trim()}>
      <div className="mt-loader-wrap">
        <div className="mt-loader-radar-ring" />
        <div className="mt-loader-radar-ring delay" />
        <div className="mt-loader-emblem-box">
          <img
            src="/icons/playstore_icon_512.png"
            alt="MyTownly"
            className="mt-loader-emblem"
          />
        </div>
      </div>
      <div className="mt-loader-text-group">
        <h3 className="mt-loader-title">{title}</h3>
        <p className="mt-loader-subtitle">{subtitle}</p>
      </div>
    </div>
  );
}
